import { clearsEmptyProperties } from '@utils/functions/clearsEmptyProperties'
import { API_URLS } from '@services/apiRoutes'

import type {
  AddEditAdditionalDepreciationRequestProps,
  ApprovalWorkflowDepreciationRequestProps,
  EditDetailedSummaryDepreciationRequestProps,
  GetAdditionalDepreciationRequestProps,
  GetBigNumbersDepreciationRequestProps,
  GetDetailedSummaryDepreciationRequestProps,
  RemoveAdditionalDepreciationRequestProps,
  ReversePreviewDepreciationRequestProps,
  ReverseWorkflowDepreciationRequestProps
} from './types'

import * as apiFunction from '@services/apiFunctions'

export const reversePreviewDepreciation = async (payload: ReversePreviewDepreciationRequestProps) => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.depreciation}/${payload.filiCode}/reverter-previa-semanal/dt-competencia/${payload.competenceDate}`,
    method: 'PATCH'
  })
}

export const releasePreviewDepreciation = async (payload: ReversePreviewDepreciationRequestProps) => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.depreciation}/${payload.filiCode}/liberar-previa-semanal/dt-competencia/${payload.competenceDate}`,
    method: 'PATCH'
  })
}

export const reverseWorkflowDepreciation = async (payload: ReverseWorkflowDepreciationRequestProps) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.finapi.depreciation}/${payload.filiCode}/restaurar-previa/dt-competencia/${payload.competenceDate}`,
    method: 'DELETE'
  })
}

export const approvalWorkflowDepreciation = async (payload: ApprovalWorkflowDepreciationRequestProps) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.finapi.depreciation}/${payload.filiCode}/envio-previa/dt-competencia/${payload.competenceDate}`,
    method: 'PATCH'
  })
}

export const getBigNumbersDepreciation = async (payload: GetBigNumbersDepreciationRequestProps) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.finapi.depreciation}/${payload.filiCode}/detalhe-previa/dt-competencia/${payload.competenceDate}`,
    method: 'GET'
  })
}

export const editDetailedSummaryDepreciation = async ({
  routeParams,
  bodyParams
}: EditDetailedSummaryDepreciationRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.depreciation}/${routeParams.filiCode}/resumo-detalhado`,
    method: 'PUT',
    body
  })
}

export const getDetailedSummaryDepreciation = async ({
  routeParams,
  bodyParams
}: GetDetailedSummaryDepreciationRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.depreciation}/${routeParams.filiCode}/resumo-detalhado`,
    method: 'POST',
    body
  })
}

export const getAdditionalDepreciationAccounts = async () => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.finapi.depreciation}/contas-depreciacao-adicional`,
    method: 'GET'
  })
}

export const getAdditionalDepreciation = async ({ routeParams, bodyParams }: GetAdditionalDepreciationRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.depreciation}/${routeParams.filiCode}/busca-depreciacao-adicional`,
    method: 'POST',
    body
  })
}

export const createAdditionalDepreciation = async ({
  routeParams,
  bodyParams
}: AddEditAdditionalDepreciationRequestProps) => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.depreciation}/${routeParams.filiCode}/depreciacao-adicional`,
    method: 'POST',
    body: bodyParams
  })
}

export const editAdditionalDepreciation = async ({ routeParams, bodyParams }: AddEditAdditionalDepreciationRequestProps) => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.depreciation}/${routeParams.filiCode}/depreciacao-adicional/${routeParams.id}`,
    method: 'PUT',
    body: bodyParams
  })
}

export const removeAdditionalDepreciation = async (payload: RemoveAdditionalDepreciationRequestProps) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.finapi.depreciation}/${payload.filiCode}/depreciacao-adicional/${payload.id}`,
    method: 'DELETE'
  })
}
